import { FormlyFieldConfig } from "@ngx-formly/core";

export const LavoriOccupazioneStep: FormlyFieldConfig[] =
    [
        {
            "key": 'jd.ditta_opt',
            "type": "mat-radio",
            "props": {
                "label": "LAVORO FATTO IN ECONOMIA SENZA L'INTERVENTO DI DITTA SPECIALIZZATA",
                "color": 'primary',
                "required": true,
                "options": [
                    { value: 'si', label: 'SI' },
                    { value: 'no', label: 'NO' },
                ],
            }
        },
        {
            "fieldGroup": [
                {
                    "wrappers": ['group-panel'],
                    "key": 'tecnici',
                    "type": 'repeat',
                    "defaultValue": [],
                    "props": {
                        "addText": '+ AGGIUNGI DITTA ESECUTRICE',
                        "label": 'ELENCO ESECUTORI DEI LAVORI',
                        "required":true
                    },
                    "fieldArray": {
                        "fieldGroupClassName": 'border border-t-4 p-4 shadow-sm rounded-xl mb-2 grid grid-flow-row-dense sm:grid-cols-1 md:grid-cols-6 grid-rows-1 gap-4',
                        "fieldGroup": [
                            {
                                "className": 'sm:col-span-1 md:col-span-6',
                                template: `<div class="font-semibold text-lg">RESPONSABILE DEI LAVORI</div>`
                            },
                            {
                                "key": 'id',
                            },
                            {
                                "className": 'sm:col-span-1 md:col-span-2',
                                "key": 'cognome',
                                "type":'mat-input',
                                "props": {
                                    "label": 'COGNOME',
                                    "required": true,
                                    "uppercase":true
                                }
                            },
                            {
                                "className": 'sm:col-span-1 md:col-span-2',
                                "key": 'nome',
                                "type":'mat-input',
                                "props": {
                                    "label": 'NOME',
                                    "required": true,
                                    "uppercase":true
                                },
                            },
                            {
                                "className": 'sm:col-span-1 md:col-span-2 font-sans',
                                "key": 'cellulare',
                                "type":'mat-input',
                                "defaultValue": '',
                                "props": {
                                    "label": 'CELLULARE',
                                },
                            },
                            {
                                "className": 'sm:col-span-1 md:col-span-6 mt-3',
                                template: `<div class="font-semibold text-lg">DITTA ESECUTRICE</div>`
                            },
                            {
                                "className": 'sm:col-span-1 md:col-span-2',
                                "key": 'denominazione',
                                "type":'mat-input',
                                "props": {
                                    "label": 'DENOMINAZIONE/RAGIONE SOCIALE',
                                    "required": true,
                                    "uppercase":true
                                },
                            },
                            {
                                "className": 'sm:col-span-1 md:col-span-2',
                                "key": 'piva',
                                "type":'mat-input',
                                "props": {
                                    "label": 'PARTITA IVA',
                                    "maxLength": 11,
                                    "required": true
                                },
                                "validators": {
                                    "validation": ['p_iva'],
                                },
                            },
                            {
                                "className": 'sm:col-span-1 md:col-span-2',
                                "key": 'cf',
                                "type":'mat-input',
                                "props": {
                                    "label": 'CODICE FISCALE',
                                    "maxLength": 16,
                                    "required": true,
                                    "uppercase": true
                                },
                            },
                            {
                                "className": 'sm:col-span-1 md:col-span-2',
                                "key": 'comune_dict',
                                "type": '#autocomplete-comune',
                                "props": {
                                    "label": 'COMUNE',
                                    "required": true,
                                }
                            },
                            {
                                "className": 'sm:col-span-1 md:col-span-1',
                                "key": 'cap',
                                "type":'mat-input',
                                "props": {
                                    "label": 'CAP',
                                    "required": true
                                }
                            },
                            {
                                "className": 'sm:col-span-1 md:col-span-2',
                                "key": 'indirizzo',
                                "type":'mat-input',
                                "props": {
                                    "label": 'INDIRIZZO SEDE LEGALE',
                                    "required": true
                                },
                            },
                            {
                                "className": 'sm:col-span-1 md:col-span-1',
                                "key": 'civico',
                                "type":'mat-input',
                                "defaultValue": '',
                                "props": {
                                    "label": 'CIVICO',
                                    "required": true
                                },
                            },
                            {
                                "className": 'sm:col-span-1 md:col-span-2',
                                "key": 'email',
                                "type": '#email',
                                "props": {
                                    "required": true
                                }
                            },
                            {
                                "className": 'sm:col-span-1 md:col-span-2',
                                "key": 'telefono',
                                "type":'mat-input',
                                "defaultValue": '',
                                "props": {
                                    "label": 'TELEFONO/CELLULARE',
                                },
                            },
                            {
                                "className": 'sm:col-span-1 md:col-span-2',
                                "key": 'fax',
                                "type":'mat-input',
                                "defaultValue": '',
                                "props": {
                                    "label": 'FAX',
                                },

                            },
                        ],
                    },
                },
            ],
            "expressions": {
                "hide": "model.jd.ditta_opt != 'no'"
            }
        }
    ]

